import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel2";
import { useSelector } from "react-redux";

const options = {
  items: 4,
  nav: true,
  rewind: true,
  // autoplay: true,
  margin: 30,
  navText: [
    '<div class="owl-prev"><i class="fa fa-angle-left"></i></div>',
    '<div class="owl-next"><i class="fa fa-angle-right"></i></div>',
  ],
  responsive: {
    0: { items: 1, dotsEach: 3, nav: false },
    768: { items: 2 },
    992: { items: 3 },
    1200: { items: 3 },
  },
};

const s3Url = "https://pms-project-s3.s3.ap-south-1.amazonaws.com/";

const Team = () => {
  const team = useSelector((state) => state.data.team);

  useEffect(() => {}, [team]);

  return (
    <React.Fragment>
      <div
        id="rs-team"
        className="rs-team pt-120 pb-120 md-pt-80 md-pb-80 xs-pb-54"
        style={{ paddingTop: "55px", paddingBottom: "80px" }}
      >
        <div className="container">
          <div className="sec-title2 text-center mb-30">
            {/* <div className="sub-text style-bg white-color">Team</div> */}
            <div className="title white-color">Expert IT Consultants</div>
          </div>
          <OwlCarousel options={options}>
            {team.map((member, index) => (
              <div key={index} className="team-item-wrap">
                <div className="team-wrap">
                  <div className="image-inner">
                    <img src={s3Url + member.profileImage} alt={member.name} />
                  </div>
                </div>
                <div className="team-content text-center">
                  <h4 className="person-name">
                    <Link to="/team/team-details">{member.name}</Link>
                  </h4>
                  <span className="designation">{member.designation}</span>
                  <ul className="team-social">
                    <li>
                      <a
                        href={member.socialLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Team;
